import {
  useMemo, useEffect, useRef, useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getProjects, clearProjects } from 'store/projects/actions';
import {
  getProjects as getProjectsSelector,
  getProjectsLoadingState,
  // getProjectsLabelMap,
  getProjectsOptions,
} from 'store/projects/selectors';
import useDebounce from 'library/hooks/use-debounce';
import { getLabelMap } from 'library/helpers/text';

const useSetList = (skip = true, defaultSnapshot = {}) => {
  const [query, onQueryChange] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const dispatch = useDispatch();
  const data = useSelector(getProjectsSelector);
  const isLoading = useSelector(getProjectsLoadingState);
  const options = useSelector(getProjectsOptions);
  const labelMapSnapshot = useRef(null);

  useEffect(() => {
    if (!skip) {
      dispatch(getProjects({ name: debouncedQuery }));
    } else if(skip && data.length) {
      dispatch(clearProjects());

      if (debouncedQuery) {
        onQueryChange('');
      }
    }
  }, [debouncedQuery, skip]);

  useEffect(() => () => {
    if(data.length) {
      dispatch(clearProjects());
    }
  }, []);

  return useMemo(() => {
    const labelMap = getLabelMap(data, {
      ...defaultSnapshot,
      ...labelMapSnapshot.current,
    });

    labelMapSnapshot.current = labelMap;

    return {
      data,
      isLoading,
      options,
      labelMap,
      onQueryChange,
    };
  }, [data, defaultSnapshot]);
};

export default useSetList;
